/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import Table from "../../components/table/Table";
import mes from "../../enums/mes";
import { formatDateTime } from "../../helpers/helpers";
import AuthContext from "../../auth/context";
import api from "../../services/api";
import AppContext from "../../container/context";

import {
  Button,
  CircularProgress,
  Grid,
  Link,
  MenuItem,
  Select,
} from "@mui/material";
import { KeyboardArrowRight } from "@mui/icons-material";

// const userData = getUserData();
const dataAtual = new Date();

const Fatura = ({ match }) => {
  const [carregando, setCarregando] = useState(true);
  const [fatura, setFatura] = useState({});
  const [faturas, setFaturas] = useState([]);
  const [faturavel, setFaturavel] = useState(false);
  const [fechandoFatura, setFechandoFatura] = useState(false);
  const [filtros, setFiltros] = useState({
    mes: match.params.mes
      ? Number(match.params.mes)
      : dataAtual.getMonth() < 11
      ? dataAtual.getMonth() + 1
      : 1,
    ano: match.params.ano
      ? Number(match.params.ano)
      : dataAtual.getMonth() < 11
      ? dataAtual.getFullYear()
      : dataAtual.getFullYear() + 1,
  });
  const { notification } = useContext(AppContext);
  const usuario = useContext(AuthContext);

  useEffect(() => {
    carregarExtrato();
  }, []);

  const carregarExtrato = (filtrosCarregar = filtros) => {
    setCarregando(true);
    api
      .get("faturas/extratoEscolaViaEscola", {
        mes: filtrosCarregar.mes,
        ano: filtrosCarregar.ano,
      })
      .then((fatura) => {
        let valorTotal = 0;

        fatura.itens.forEach((item) => {
          valorTotal += item.pedidoPagamentoValor;
        });

        fatura.dataLimitePagamento = `${formatDateTime(
          fatura.vencimentoBase,
          "D/M/Y"
        )}`;
        fatura.valorTotal = (
          (valorTotal + fatura.multa + fatura.juros) /
          100
        ).toFixed(2);

        setFatura(fatura);
        setCarregando(false);

        listarFaturas(fatura, filtrosCarregar);
      })
      .catch((e) => notification("error", `Erro ao carregar a fatura:  ${e}`));
  };

  const listarFaturas = (fatura, filtrosCarregar = filtros) => {
    api
      .get("faturas/listarViaEscola", {
        mes: filtrosCarregar.mes,
        ano: filtrosCarregar.ano,
      })
      .then((faturas) => {
        if (faturas.length > 0) {
          let extratoFaturavel = true;
          
          faturas.forEach((item) => {
            console.log(item);
            if (item.vencimento) item.vencimento = `${formatDateTime(item.vencimento, "D/M/Y")}`;
            if (item.cancelamento){
              item.situacao = `Cancelada (${formatDateTime(
                item.cancelamento,
                "D/M/Y h:m"
              )})`;
            }              
            if (item.expiracao) item.situacao = `Expirada (${item.expiracao})`;
            if (item.pagamento) {
              item.situacao = `Pagamento registrado (${formatDateTime(
                item.pagamento,
                "D/M/Y h:m"
              )})`;
              extratoFaturavel = false;
            }
            if (item.pendente) {
              item.situacao = `Pendente`;
              extratoFaturavel = false;
            }

            if (!item.situacao) item.situacao = "Pagamento não registrado.";
          });

          setFaturavel(extratoFaturavel);
          setFaturas(faturas);
        } else {
          setFaturavel(fatura.faturavel);
          setFaturas([]);
        }
      })
      .catch((e) => notification("error", `Erro ao listar as faturas: ${e}`));
  };

  const filtrar = (novosFiltros) => {
    const filtrosAtualizados = { ...filtros };

    if (novosFiltros.mes) filtrosAtualizados.mes = novosFiltros.mes;
    if (novosFiltros.ano) filtrosAtualizados.ano = novosFiltros.ano;

    setFiltros(filtrosAtualizados);
    carregarExtrato(filtrosAtualizados);
  };

  const fecharFatura = () => {
    setFechandoFatura(true);

    const dadosFatura = {
      mes: fatura.mes,
      ano: fatura.ano,
    };

    api
      .put("faturas/faturarEscola", dadosFatura)
      .then((faturaGerada) => {
        setFechandoFatura(false);

        if (faturaGerada.id) {
          notification("success", "Fatura gerada com sucesso!");
          return carregarExtrato();
        }
      })
      .catch((err) => {
        const { data } = err.response;
        switch (data[0]) {
          case 1:
            setFechandoFatura(false);

            return notification("error", "Período inválido");

          case 2:
            setFechandoFatura(false);

            return notification("error", "Sem pagamentos para faturar");

          case 3:
            setFechandoFatura(false);

            return notification(
              "error",
              "Já existe fatura ativa para o período"
            );

          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  // const gerarFaturaAtraso = () => {
  //   setFechandoFatura(true);

  //   const dadosFatura = {
  //     usuarioId: usuario.usuario.id,
  //     mes: fatura.mes,
  //     ano: fatura.ano,
  //     atraso: true,
  //   };

  //   api
  //     .post("faturas/fechamentoEscola", dadosFatura)
  //     .then((faturaGerada) => {
  //       setFechandoFatura(false);

  //       if (faturaGerada.id) {
  //         notification("success", "Fatura gerada com sucesso!");
  //         return carregarExtrato();
  //       }

  //       notification(
  //         "error",
  //         "Não foi possível gerar a fatura. Verifique os dados e tente novamente."
  //       );
  //     })
  //     .catch((e) => {
  //       notification("error", `Erro ao gerar a fatura: ${e}`);
  //       setFechandoFatura(false);
  //     });
  // };

  const tbPagamentos = fatura.itens ? montarTabelaPagamentos(fatura) : [];
  const tbFaturasGeradas =
    faturas.length > 0 ? montarTabelaFaturasGeradas(faturas) : [];

  return (
    <>
      <Grid container>
        <Grid item md={12}>
          <div className="main-container">
            <Grid container>
              <Grid item md={6}>
                <h3>Mês</h3>
                <Grid container>
                  <Grid item md={4}>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={filtros.mes}
                      onChange={(e) => filtrar({ mes: e.target.value })}
                    >
                      {Object.entries(mes).map((entry, key) => (
                        <MenuItem key={key} value={entry[1]}>
                          {mes.desc(entry[1])}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item md={6}>
                <h3>Ano</h3>
                <Grid container>
                  <Grid item md={4}>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={filtros.ano}
                      onChange={(e) => filtrar({ ano: e.target.value })}
                    >
                      {[-2, -1, 0, 1].map((i, key) => (
                        <MenuItem key={key} value={filtros.ano + i}>
                          {filtros.ano + i}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
      {carregando || !fatura.itens ? (
        <CircularProgress />
      ) : (
        <>
          <Grid container>
            <Grid item md={12}>
              <div className="main-container">
                <Grid container>
                  <Grid item md={3}>
                    <h4>Escola</h4>
                    <p>{fatura.escolaNomeFantasia}</p>
                  </Grid>
                  <Grid item md={3}>
                    <h4>Data referência para pagamento</h4>
                    <p>{fatura.dataLimitePagamento}</p>
                  </Grid>
                  <Grid item md={3}>
                    <h4>Valor total</h4>
                    <p>{`R$ ${fatura.valorTotal}`}</p>
                  </Grid>
                  {faturavel && !carregando && (
                    <Grid item md={3}>
                      {fechandoFatura ? (
                        <CircularProgress />
                      ) : fatura.pagamentoEmAtraso ? (
                        <Button
                          color="error"
                          variant="contained"
                          round
                          onClick={fecharFatura}
                        >
                          Gerar nova fatura <KeyboardArrowRight />
                        </Button>
                      ) : (
                        <Button color="primary" round onClick={fecharFatura}>
                          Fechar fatura <KeyboardArrowRight />
                        </Button>
                      )}
                    </Grid>
                  )}
                </Grid>
              </div>
            </Grid>
          </Grid>
          {faturas.length > 0 && (
            <>
              <div className="main-container">
                <h3>Faturas geradas</h3>
                <Grid container>
                  <Grid item md={12}>
                    <Table
                      tableHead={[
                        "ID DA FATURA NA IUGU",
                        "LINK PARA PAGAMENTO",
                        "VENCIMENTO",
                        "SITUAÇÃO",
                      ]}
                      tableData={tbFaturasGeradas}
                    />
                  </Grid>
                </Grid>
              </div>
            </>
          )}
          {fatura.itens && fatura.itens.length > 0 ? (
            <>
              <div className="main-container">
                <h3>Pagamentos</h3>
                <Grid container>
                  <Grid item md={12}>
                    <Table
                      tableHead={["DESCRIÇÃO", "VALOR"]}
                      tableData={tbPagamentos}
                    />
                  </Grid>
                </Grid>
              </div>
            </>
          ) : (
            <h3>Ainda não há itens na fatura deste mês.</h3>
          )}
        </>
      )}
    </>
  );
};

export default Fatura;

const montarTabelaFaturasGeradas = (faturas) => {
  const registros = [];

  faturas.forEach((item) => {
    registros.push([
      <p>{item.iuguId}</p>,
      <a target="_blank" href={item.iuguUrl}>
        {item.iuguUrl}
      </a>,
      <p>{item.vencimento}</p>,
      <p>{item.situacao}</p>,
    ]);
  });

  return registros;
};

const montarTabelaPagamentos = (fatura) => {
  const registros = [];

  fatura.itens.forEach((item) => {
    registros.push([
      <Link
        href={`/app/pedidos-escola/pedido/${item.pedidoId}`}
        target="_blank"
      >
        <p>{`Pedido nº ${item.pedidoId} (parcela ${item.pedidoPagamentoParcelaNumero}/${item.pedidoNumeroParcelas})`}</p>
      </Link>,
      `R$ ${(item.pedidoPagamentoValor / 100).toFixed(2)}`,
    ]);
  });

  if (fatura.pagamentoEmAtraso && fatura.diasAtraso > 10) {
    registros.push([
      <p>{`Multa por pagamento em atraso (mais de 10 dias)`}</p>,
      `R$ ${(fatura.multa / 100).toFixed(2)}`,
    ]);
    registros.push([
      <p>{`Juros (${fatura.diasAtraso} dias)`}</p>,
      `R$ ${(fatura.juros / 100).toFixed(2)}`,
    ]);
  }

  registros.push([<b>Total:</b>, `R$ ${fatura.valorTotal}`]);

  return registros;
};
